module.exports = __webpack_public_path__ + "static/img/settle-bc4.8fe5b545.png";